import { IconButton, MenuItem, Paper, Stack } from "@mui/material"
import { Control, UseFormWatch } from "react-hook-form"
import { TSale } from "../../../../core/types/Sale"
import TextFieldRequired from "../../../Inputs/TextFieldRequired"
import { numberOnly } from "../../../../masks/masks"
import SelectRequired from "../../../Inputs/SelectRequired"
import states from "../../../../core/data/states"
import React from "react"

interface ICheckoutAddress8 {
  control: Control<TSale, any>
  loading: boolean
  searchedZipCode: boolean
  watch: UseFormWatch<TSale>
  saveLostSale: () => void
  clearErrors: () => void
  searchZipCode: (loading: boolean, zipCode: string) => void
  handleAddresNumberKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void
  handleAddresComplementKeyDown: (
    e: React.KeyboardEvent<HTMLDivElement>
  ) => void
  onSendPixel: () => void
}

const CheckoutAddress8 = ({
  control,
  loading,
  searchedZipCode,
  watch,
  saveLostSale,
  clearErrors,
  searchZipCode,
  handleAddresNumberKeyDown,
  handleAddresComplementKeyDown,
  onSendPixel,
}: ICheckoutAddress8) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: "1px solid #DCDDDE",
        borderRadius: "20px",
        backgroundColor: "#FFF",
      }}
    >
      <Stack direction="column" spacing={2} data-cy="containerAddress">
        <TextFieldRequired
          control={control}
          borderRadius={16}
          fieldName="address.zipCode"
          label="CEP"
          placeholder="Seu CEP"
          inputProps={{
            inputMode: "numeric",
            maxLength: 9,
            "data-cy": "addressZipCode",
            "data-testid": "addressZipCode",
          }}
          dataCyErrorLabel="addressZipCodeError"
          onFieldExit={saveLostSale}
          clearErrors={clearErrors}
          validate={(value) =>
            !value || value == "" ? true : numberOnly(value).length === 8
          }
          endAdornment={
            <IconButton
              size="small"
              onClick={() => searchZipCode(loading, watch("address.zipCode"))}
            >
              <img alt="Search" src="/assets/icons/common/search.svg" />
            </IconButton>
          }
          scheme="greenish"
        />

        <Stack
          direction="column"
          spacing={2}
          sx={{ display: searchedZipCode ? "block" : "none" }}
        >
          <TextFieldRequired
            control={control}
            borderRadius={16}
            fieldName="address.street"
            label="Endereço"
            clearErrors={clearErrors}
            inputProps={{
              maxLength: 64,
              "data-cy": "addressStreet",
              "data-testid": "addressStreet",
            }}
            dataCyErrorLabel="addressStreetError"
            scheme="greenish"
          />

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextFieldRequired
              control={control}
              borderRadius={16}
              fieldName="address.number"
              label="Número"
              onKeyDown={handleAddresNumberKeyDown}
              clearErrors={clearErrors}
              inputProps={{
                "data-cy": "addressNumber",
                "data-testid": "addressNumber",
              }}
              dataCyErrorLabel="addressNumberError"
              scheme="greenish"
            />

            <TextFieldRequired
              control={control}
              borderRadius={16}
              fieldName="address.complement"
              label="Complemento"
              required={false}
              onKeyDown={handleAddresComplementKeyDown}
              clearErrors={clearErrors}
              scheme="greenish"
            />
          </Stack>
          <TextFieldRequired
            control={control}
            borderRadius={16}
            fieldName="address.neighborhood"
            label="Bairro"
            clearErrors={clearErrors}
            inputProps={{
              "data-cy": "addressNeighborhood",
              "data-testid": "addressNeighborhood",
            }}
            dataCyErrorLabel="addressNeighborhoodError"
            scheme="greenish"
          />
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextFieldRequired
              control={control}
              borderRadius={16}
              fieldName="address.city"
              label="Cidade"
              clearErrors={clearErrors}
              onFieldExit={onSendPixel}
              inputProps={{
                "data-cy": "addressCity",
                "data-testid": "addressCity",
              }}
              dataCyErrorLabel="addressCityError"
              scheme="greenish"
            />

            <SelectRequired
              control={control}
              borderRadius={16}
              fieldName="address.state"
              label="Estado"
              onFieldExit={onSendPixel}
              inputProps={{
                "data-cy": "addressState",
                "data-testid": "addressState",
              }}
              scheme="greenish"
            >
              {states.map((state) => (
                <MenuItem key={`state${state.sigla}`} value={state.sigla}>
                  {state.nome}
                </MenuItem>
              ))}
            </SelectRequired>
          </Stack>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default CheckoutAddress8
